import React, { ComponentProps } from 'react';

import { ConnectDragSource } from 'react-dnd';

import { cn } from '@/lib/utils';

import styles from './Box.module.scss';

type BoxProps = { dragRef?: ConnectDragSource };

const Box = ({
  children,
  className,
  dragRef,
  ref,
  ...props
}: BoxProps & ComponentProps<'div'> & { ref?: React.Ref<HTMLDivElement> }) => {
  const classesFromProps =
    typeof className === 'string' ? className : className ? [...className] : [];

  return (
    <div
      ref={
        dragRef
          ? (node) => {
              dragRef(node);
            }
          : ref
      }
      className={cn(classesFromProps, { [styles.box]: true })}
      {...props}
    >
      {children}
    </div>
  );
};

export default Box;
